import { createRouter, createWebHistory } from 'vue-router'

import { SHOW_SUPPORT_CHAT } from '@/constants/features'
import { ROUTE } from '@/constants/routes'
import { isOnboarded } from '@/utils/onboarding'

/**
 * Роуты повторяют структуру макета: 5 табов bottom nav + вложенные экраны.
 * Имена роутов совпадают с id табов BottomNav.
 */
export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: ROUTE.home },
    {
      path: ROUTE.start,
      name: 'start',
      component: () => import('@/pages/StartPage.vue'),
    },
    {
      path: ROUTE.auth,
      name: 'auth',
      component: () => import('@/pages/AuthPage.vue'),
    },
    {
      path: ROUTE.home,
      name: 'home',
      component: () => import('@/pages/HomePage.vue'),
    },
    {
      path: ROUTE.menu,
      name: 'menu',
      component: () => import('@/pages/MenuPage.vue'),
    },
    {
      path: ROUTE.cart,
      name: 'cart',
      component: () => import('@/pages/CartPage.vue'),
    },
    {
      path: ROUTE.checkout,
      name: 'checkout',
      component: () => import('@/pages/CheckoutPage.vue'),
    },
    {
      path: ROUTE.orders,
      name: 'orders',
      component: () => import('@/pages/OrdersPage.vue'),
    },
    {
      path: ROUTE.order,
      name: 'order',
      component: () => import('@/pages/OrderStatusPage.vue'),
    },
    {
      path: ROUTE.profile,
      name: 'profile',
      component: () => import('@/pages/ProfilePage.vue'),
    },
    {
      path: ROUTE.favorites,
      name: 'favorites',
      component: () => import('@/pages/FavoritesPage.vue'),
    },
    {
      path: ROUTE.addresses,
      name: 'addresses',
      component: () => import('@/pages/AddressesPage.vue'),
    },
    {
      path: ROUTE.cards,
      name: 'cards',
      component: () => import('@/pages/CardsPage.vue'),
    },
    {
      path: ROUTE.promo,
      name: 'promo',
      component: () => import('@/pages/PromoPage.vue'),
    },
    {
      path: ROUTE.notifications,
      name: 'notifications',
      component: () => import('@/pages/NotificationsPage.vue'),
    },
    {
      path: ROUTE.settings,
      name: 'settings',
      component: () => import('@/pages/SettingsPage.vue'),
    },
    /*
     * С выключенным чатом экраны переписки уводят на главную: иначе в них
     * можно было бы попасть по прямой ссылке или диплинку, минуя спрятанные
     * кнопки. Не убираем совсем, чтобы вместо пустого экрана был редирект.
     */
    SHOW_SUPPORT_CHAT
      ? {
        path: ROUTE.chat,
        name: 'chat',
        component: () => import('@/pages/ChatPage.vue'),
      }
      : { path: ROUTE.chat, redirect: ROUTE.home },
    SHOW_SUPPORT_CHAT
      ? {
        path: ROUTE.chatRoom,
        name: 'chat-room',
        component: () => import('@/pages/ChatRoomPage.vue'),
      }
      : { path: ROUTE.chatRoom, redirect: ROUTE.home },
    {
      path: ROUTE.uiKit,
      name: 'ui-kit',
      component: () => import('@/pages/UiKitPage.vue'),
    },
  ],
  scrollBehavior: () => ({ top: 0 }),
})

/**
 * Страницы, живущие вне онбординга: отдельный вход и витрина компонентов.
 * Проверки авторизации по страницам больше нет — она вошла в `isOnboarded()`:
 * без аккаунта до приложения вообще не добраться.
 */
const OUTSIDE_ONBOARDING = new Set<string>([ROUTE.auth, ROUTE.uiKit])

router.beforeEach((to) => {
  /* Онбординг пройден — стартовому экрану больше нечего показывать */
  if (to.path === ROUTE.start) return isOnboarded() ? { path: ROUTE.home } : true
  if (OUTSIDE_ONBOARDING.has(to.path)) return true

  return isOnboarded() ? true : { path: ROUTE.start }
})
